import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPkSk, IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { ApiService } from '../../Services/api.service';

@Injectable({
	providedIn: 'root',
})
export class RoleService {
	constructor(private api: ApiService, private http: HttpClient) {}

	getRoles(page: number = 1) {
		return this.api.get<any>(`/roles?_size=10&_page=${page}`);
	}

	getFilterRoles(url: string) {
		return this.api.get<any>(`/roles/query${url}`);
	}

	getAllRoles() {
		return this.api.get<any>(`/roles?_size=false`);
	}

	deleteRole(roles: IPkSk[]) {
		return this.api.delete<any>(`/roles`, { body: { roles } });
	}
	postRole(role: IRole) {
		return this.api.post<any>(`/roles`, role);
	}
	updateRole(role: IRole, id: IPkSk) {
		return this.api.patch<any>(`/roles/${id.pk}/${id.sk}`, role);
	}
}
